import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaRegSave, FaIndustry, FaFileMedical, FaMoneyBillWave, FaPlusCircle } from "react-icons/fa";
import PageCreateHeader from "../../components/PageCreateHeader";

const CreateObat = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    dosis: "",
    harga_jual: "", // Akan dikonversi ke integer
    harga_beli: "", // Akan dikonversi ke integer
    produsen: "",
    description: "",
    stock: "", // Akan dikonversi ke integer
    isi: "", 
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fungsi untuk menangani perubahan input
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Fungsi untuk menangani submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const token = localStorage.getItem("token");
    if (!token) {
      setError("Token tidak ditemukan! Pastikan pengguna sudah login.");
      setLoading(false);
      return;
    }

    // Konversi nilai yang harus berupa angka (integer)
    const formattedData = {
      ...formData,
      harga_jual: parseInt(formData.harga_jual, 10), // Konversi ke integer
      harga_beli: parseInt(formData.harga_beli, 10), // Konversi ke integer
      stock: parseInt(formData.stock, 10), // Konversi ke integer
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/v1/drug`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formattedData), // Kirim data yang sudah dikonversi
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Gagal menambahkan obat");
      }

      alert("Obat berhasil ditambahkan!");
      navigate("/obat"); // Redirect ke halaman daftar obat setelah sukses
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col space-y-6 p-5 bg-gray-50 w-full min-w-0">
      <PageCreateHeader
        icon={FaPlusCircle}
        title="Tambah Obat"
        description="Masukkan data obat baru untuk katalog"
        breadcrumbs={[
          { label: "Enterprise", to: "/" },
          { label: "Obat", to: "/obat-paket/obat" },
          { label: "Tambah Obat" },
        ]}
      />

    {error && <p className="text-red-500 text-center">{error}</p>}

    <form onSubmit={handleSubmit} className="bg-white p-8 shadow-xl rounded-xl w-full space-y-6 border border-gray-100">
      <div className="grid grid-cols-1 gap-6">
        <div>
          <label className="block text-gray-700 font-medium">Nama Obat:</label>
          <div className="flex items-center border rounded-lg p-2 mt-2 bg-gray-50">
            <FaFileMedical className="text-gray-500 mr-2" />
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full bg-gray-50 text-gray-700 outline-none"
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Dosis:</label>
          <div className="flex items-center border rounded-lg p-2 mt-2 bg-gray-50">
            <FaIndustry className="text-gray-500 mr-2" />
            <input
              type="text"
              name="dosis"
              value={formData.dosis}
              onChange={handleChange}
              className="w-full bg-gray-50 text-gray-700 outline-none"
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Harga Jual (Rp):</label>
          <div className="flex items-center border rounded-lg p-2 mt-2 bg-gray-50">
            <FaMoneyBillWave className="text-gray-500 mr-2" />
            <input
              type="number"
              name="harga_jual"
              value={formData.harga_jual}
              onChange={handleChange}
              className="w-full bg-gray-50 text-gray-700 outline-none"
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Harga Beli (Rp):</label>
          <div className="flex items-center border rounded-lg p-2 mt-2 bg-gray-50">
            <FaMoneyBillWave className="text-gray-500 mr-2" />
            <input
              type="number"
              name="harga_beli"
              value={formData.harga_beli}
              onChange={handleChange}
              className="w-full bg-gray-50 text-gray-700 outline-none"
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Produsen:</label>
          <div className="flex items-center border rounded-lg p-2 mt-2 bg-gray-50">
            <FaIndustry className="text-gray-500 mr-2" />
            <input
              type="text"
              name="produsen"
              value={formData.produsen}
              onChange={handleChange}
              className="w-full bg-gray-50 text-gray-700 outline-none"
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-gray-700 font-medium">Deskripsi:</label>
          <div className="flex items-center border rounded-lg p-2 mt-2 bg-gray-50">
            <FaFileMedical className="text-gray-500 mr-2" />
            <input
              type="text"
              name="description"
              value={formData.description}
              onChange={handleChange}
              className="w-full bg-gray-50 text-gray-700 outline-none"
            />
          </div>
        </div>
{/* 
        <div>
          <label className="block text-gray-700 font-medium">Stock:</label>
          <div className="flex items-center border rounded-lg p-2 mt-2 bg-gray-50">
            <FaIndustry className="text-gray-500 mr-2" />
            <input
              type="number"
              name="stock"
              value={formData.stock}
              onChange={handleChange}
              className="w-full bg-gray-50 text-gray-700 outline-none"
              required
            />
          </div>
        </div> */}

        <div>
          <label className="block text-gray-700 font-medium">Isi:</label>
          <div className="flex items-center border rounded-lg p-2 mt-2 bg-gray-50">
            <FaIndustry className="text-gray-500 mr-2" />
            <input
              type="text"
              name="isi"
              value={formData.isi}
              onChange={handleChange}
              className="w-full bg-gray-50 text-gray-700 outline-none"
              required
            />
          </div>
        </div>
      </div>

      <button
        type="submit"
        className="w-full bg-blue-600 text-white p-3 rounded-lg shadow-md hover:bg-blue-700 transition duration-300 flex items-center justify-center"
        disabled={loading}
      >
        {loading ? (
          <>
            <FaRegSave className="animate-spin mr-2" />
            Menyimpan...
          </>
        ) : (
          <>
            <FaPlusCircle className="mr-2" />
            Tambah Obat
          </>
        )}
      </button>
    </form>
  </div>
  );
};

export default CreateObat;
